import { themeClasses as T } from "../../atlas/utils";

export interface SelectionSummaryProps {
  durationMinutes?: string | number;
  lessonCount?: number;
  testId?: string;
}

export function SelectionSummary({
  durationMinutes = 0,
  lessonCount = 0,
  testId = "selection-summary",
}: SelectionSummaryProps) {
  return (
    <div className="space-y-2 mb-4" data-testid={testId}>
      <div>
        <div className={`text-xs uppercase tracking-wide ${T.textGray500}`}>Duration</div>
        <div className={`text-lg font-medium ${T.textPrimary}`}>{durationMinutes}</div>
      </div>

      <div>
        <div className={`text-xs uppercase tracking-wide ${T.textGray500}`}>Lessons</div>
        <div className={`text-lg font-medium ${T.textPrimary}`}>{lessonCount}</div>
      </div>
    </div>
  );
}
